export const texts = {
  presented: {
    de: 'Vorgestellt',
    en: 'Presented'
  },
  firstInterview: {
    de: 'Erstgespräch',
    en: 'First interview'
  },
  applicationWithdrawn: {
    de: 'Bewerbung zurückgezogen',
    en: 'Application withdrawn'
  },
  rejected: {
    de: 'Abgelehnt',
    en: 'Rejected'
  },
  hired: {
    de: 'Eingestellt',
    en: 'Hired'
  }
};
